/**
 * Elite showcase copy, verbatim from the ticket (Asana 1219949663037427).
 */
import { StudioFeatureKey } from './constants';

export const STUDIO_COPY = {
  eyebrow: 'ELITE COSMETICS',
  headline: 'Make your profile unmistakable.',
  sub: 'Every perk shows up where traders actually look. Flip between Free and Elite, pick a feature, and make it yours.',
  modeHint: {
    elite: 'This is you on Elite.',
    free: 'This is you today.',
  },
  chatHint: '+ upload your own emoji for the whole community',
  socialTryIt: 'Paste any link. Twitter, Discord, YouTube, Twitch and Moxfield icons are detected automatically.',
  trophyTryIt: 'Free shows 1 badge. Elite shows your best 4. Toggle Free / Elite above to compare.',
  socialLocked: 'Social links are an Elite perk',
  unlock: 'Unlock with Elite',
  badgeChips: ['Trades', 'Leaderboard', 'Inbox', 'Profile'],
  loggedOutUsername: 'yourname',
  loggedOutSlug: 'usr_a8f3k2',
} as const;

export const STUDIO_FEATURES: Record<StudioFeatureKey, { title: string; description: string; chip: string }> = {
  border: {
    title: 'Animated Avatar Border',
    description: 'A glowing gradient ring around your avatar, everywhere on the platform. Pick your colors.',
    chip: 'Avatar border',
  },
  chat: {
    title: 'Chat Customization',
    description: 'Custom gradient chat bubbles, plus your own emoji for the whole community to react with.',
    chip: 'Chat',
  },
  badge: {
    title: 'Elite Badge Everywhere',
    description: "Next to your name on trades, leaderboard, inbox, and profile. Everyone knows you're Elite.",
    chip: 'Elite badge',
  },
  url: {
    title: 'Custom Profile URL',
    description: 'Claim a short, memorable URL. Share it on Discord, Reddit, or at your LGS.',
    chip: 'Custom URL',
  },
  social: {
    title: 'Social Profile Links',
    description: 'Up to 5 links on your profile card so traders can find you everywhere.',
    chip: 'Socials',
  },
  trophy: {
    title: 'Expanded Trophy Case',
    description: 'Showcase up to 4 achievement badges that represent you best.',
    chip: 'Trophies',
  },
};

export const FEES_COPY = {
  eyebrow: 'ZERO POINT-FEES',
  headline: 'Keep every point you trade.',
  lockIn: 'Sign up during the launch promotion and your zero-fee rate is locked in for the life of your membership.',
  chip: 'LIMITED-TIME FOR FOUNDING MEMBERS',
  sliderLabel: 'Points you trade each month',
  captionMine: 'Your average over the last 90 days',
  captionExample: 'An example month',
  captionAdjusted: 'Adjusted',
  reset: 'Reset to mine',
  freeTile: 'Free',
  eliteTile: 'Elite',
  maintenance: 'Maintenance fee',
  maintenanceShort: 'Maintenance',
  perMonth: 'per month',
  perMonthShort: '/ month',
  waived: 'WAIVED',
  savings: 'You save, every year',
  stopPaying: 'Stop paying fees',
} as const;

export const SMS_COPY = {
  eyebrow: 'SMS TRADE ALERTS',
  headline: 'Never miss a trade.',
  body: 'Get a text the moment a trader wants your card and can afford it. Act fast on the trades that matter.',
  toasts: [
    '@kellan_r wants A Tale for the Ages (Foil) from your have list and can afford it.',
    'New match: @ruby.trades has 3 cards on your want list.',
    '@agatha_bakes sent you a trade offer worth 45 points.',
  ],
  free: 'FREE',
  elite: 'ELITE',
  perMonth: 'alerts / month',
} as const;

export const FINAL_CTA_COPY = {
  headline: 'Trading is free. Always.',
  body: 'A trading platform only works when everyone can trade. No paid matchmaking, no trade slots, no points-for-cash. Elite is how you support the platform and make your account your own.',
} as const;
